'use client';

import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useLanguage } from '@/i18n/LanguageProvider';
import LanguageSwitch from '@/components/LanguageSwitch';
import SideMenu from '@/components/SideMenu';
import { MAIN_NAV_ITEMS } from '@/config/mainNav';

function desktopNavClass(accent: 'pink' | 'gold') {
  if (accent === 'pink') {
    return 'border border-rose-400/45 text-rose-100/95 bg-rose-950/35 hover:bg-rose-900/45 whitespace-nowrap';
  }
  return 'border border-[#B9AE9A]/40 text-[#B9AE9A] bg-[#B9AE9A]/5 hover:bg-[#B9AE9A]/12 whitespace-nowrap';
}

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useLanguage();

  return (
    <>
      <header className="bg-[#1C1C1C] border-b border-[#B9AE9A]/10 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
          <div className="flex items-center gap-3 lg:gap-4">
            <div className="flex shrink-0 items-center">
              <Link to="/" className="text-[#B9AE9A] hover:text-white transition-colors text-lg font-medium">
                PathIN
              </Link>
            </div>
            <nav
              className="hidden lg:flex flex-1 flex-wrap items-center justify-center gap-2 min-w-0 px-1"
              aria-label={t('nav.main')}
            >
              {MAIN_NAV_ITEMS.map((item) => (
                <Link
                  key={item.to + item.labelKey}
                  to={item.to}
                  className={`rounded-md px-2.5 py-1.5 text-xs xl:text-sm font-medium tracking-wide transition-colors ${desktopNavClass(item.accent)}`}
                >
                  {t(item.labelKey)}
                </Link>
              ))}
            </nav>
            <div className="flex shrink-0 items-center gap-4 ml-auto">
              <LanguageSwitch />
              <button
                type="button"
                onClick={() => setIsMenuOpen(true)}
                className="lg:hidden text-white/80 hover:text-white transition-colors p-1"
              >
                <span className="sr-only">{t('nav.menu')}</span>
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </header>
      <SideMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
    </>
  );
} 